import React from "react";
import "./Stories.scss";
import Storie from "../Storie/Storie";

const Stories = () => {
  return (
    <div className="stories-div">
      <div className="stories">
        <Storie
          name="Usuario 1"
          alt="Storie 1"
          url="https://i.picsum.photos/id/100/120/200.jpg"
        />
        <Storie
          name="Usuario 2"
          alt="Storie 2"
          url="https://i.picsum.photos/id/101/120/200.jpg"
        />
        <Storie
          name="Usuario 3"
          alt="Storie 3"
          url="https://i.picsum.photos/id/102/120/200.jpg"
        />
        <Storie
          name="Usuario 4"
          alt="Storie 4"
          url="https://i.picsum.photos/id/103/120/200.jpg"
        />
        <Storie
          name="Usuario 5"
          alt="Storie 5"
          url="https://i.picsum.photos/id/104/120/200.jpg"
        />
      </div>
    </div>
  );
};

export default Stories;
